import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kind", "section", "list", "template"]

  connect() {
    this.nextIndex = Date.now()
    this.toggle()
  }

  toggle() {
    const enabled = this.kindTarget.value === "competition"
    this.sectionTarget.hidden = !enabled
    this.listTarget.querySelectorAll("input").forEach(input => {
      input.disabled = !enabled
    })
  }

  add() {
    const positions = Array.from(this.listTarget.querySelectorAll("[data-series-row]:not([hidden]) input[name$='[position]']"), input => Number(input.value) || 0)
    const content = this.templateTarget.innerHTML.replaceAll("NEW_SERIES", this.nextIndex++)
    this.listTarget.insertAdjacentHTML("beforeend", content)
    this.listTarget.lastElementChild.querySelector("input[name$='[position]']").value = Math.max(0, ...positions) + 1
  }

  remove(event) {
    const row = event.target.closest("[data-series-row]")
    row.querySelector("[data-destroy-field]").value = "1"
    row.hidden = true
  }
}
